import * as clientConfig0 from '/workspaces/ft-docs/node_modules/@vuepress/plugin-active-header-links/lib/client/config.js'
import * as clientConfig1 from '/workspaces/ft-docs/node_modules/@vuepress/plugin-back-to-top/lib/client/config.js'
import * as clientConfig2 from '/workspaces/ft-docs/node_modules/@vuepress/plugin-copy-code/lib/client/config.js'
import * as clientConfig3 from '/workspaces/ft-docs/node_modules/@vuepress/plugin-markdown-hint/lib/client/config.js'
import * as clientConfig4 from '/workspaces/ft-docs/docs/.vuepress/.temp/git/config.js'
import * as clientConfig5 from '/workspaces/ft-docs/node_modules/@vuepress/plugin-medium-zoom/lib/client/config.js'
import * as clientConfig6 from '/workspaces/ft-docs/node_modules/@vuepress/plugin-nprogress/lib/client/config.js'
import * as clientConfig7 from '/workspaces/ft-docs/docs/.vuepress/.temp/prismjs/config.js'
import * as clientConfig8 from '/workspaces/ft-docs/docs/.vuepress/.temp/markdown-tab/config.js'
import * as clientConfig9 from '/workspaces/ft-docs/node_modules/@vuepress/plugin-theme-data/lib/client/config.js'
import * as clientConfig10 from '/workspaces/ft-docs/node_modules/@vuepress/theme-default/lib/client/config.js'
import * as clientConfig11 from '/workspaces/ft-docs/docs/.vuepress/.temp/register-components/clientConfig.d4dabb74.js'
import * as clientConfig12 from '/workspaces/ft-docs/node_modules/@vuepress/plugin-google-analytics/lib/client/config.js'
import * as clientConfig13 from '/workspaces/ft-docs/node_modules/@vuepress/plugin-meilisearch/lib/client/config.js'
import * as clientConfig14 from '/workspaces/ft-docs/docs/.vuepress/client.ts'

export const clientConfigs = [
  clientConfig0,
  clientConfig1,
  clientConfig2,
  clientConfig3,
  clientConfig4,
  clientConfig5,
  clientConfig6,
  clientConfig7,
  clientConfig8,
  clientConfig9,
  clientConfig10,
  clientConfig11,
  clientConfig12,
  clientConfig13,
  clientConfig14,
].map((m) => m.default).filter(Boolean)
